/**
 * The Forms of Fuckery as the page knows them. The wire names them; the core
 * takes a bitmask on the Cue, and these are its bits (`WK_RATCHET`,
 * `WK_ROLL`, `WK_REVERSE`, `WK_ECHO`, `WK_SPRING`, `WK_CRUSH`, `WK_DRIVE`, `WK_STRINGS` in `dsp/walker.c`). The order is
 * the panel's, and later Forms join at the end. Pure.
 */

export interface FormSpec {
  /** The name on the wire. */
  readonly name: string
  /** The core's bit for it. */
  readonly bit: number
  /** What the panel calls it. */
  readonly label: string
}

export const FORMS: ReadonlyArray<FormSpec> = [
  { name: "ratchet", bit: 1, label: "ratchet" },
  { name: "roll", bit: 2, label: "roll" },
  { name: "reverse", bit: 4, label: "reverse" },
  { name: "echo", bit: 8, label: "echo" },
  { name: "spring", bit: 16, label: "spring" },
  { name: "crush", bit: 32, label: "crush" },
  { name: "drive", bit: 64, label: "drive" },
  { name: "strings", bit: 128, label: "strings" }
]

/** The core's bitmask for a hit's Forms: 0 for a plain hit or an unanswered one. A name this page does not know adds nothing. */
export const maskOf = (forms: ReadonlyArray<string> | undefined): number =>
  FORMS.reduce((mask, form) => (forms?.includes(form.name) === true ? mask | form.bit : mask), 0)

/** A Step's length in audio frames at this tempo: a sixteenth, the span a hit's repeats fill. */
export const spanFrames = (bpm: number, sampleRate: number): number => (15 / bpm) * sampleRate
